import React from 'react';
import cx from 'classnames';
import { CardElement } from '@stripe/react-stripe-js';
import { colors } from '@vimily/bonjoro-ui-components-v2/dist/theme';
import { StripeCardElementOptions } from '@stripe/stripe-js';
import { CreditCardValue } from '~/types/stripe';

const CARD_INPUT_OPTIONS: StripeCardElementOptions = {
  hidePostalCode: true,
  style: {
    base: {
      fontSize: '21px',
      color: colors.neutral[800],
      backgroundColor: colors.yellow[50],
      letterSpacing: '1px',
      fontWeight: 800,
      '::placeholder': {
        color: colors.neutral[200],
      },
      lineHeight: '40px',
    },
  },
};

export interface CreditCardInputProps {
  className?: string;
  onChange?: (value: CreditCardValue) => void;
}

export function CreditCardInput({ className, onChange }: CreditCardInputProps) {
  return (
    <CardElement
      className={cx(className, [
        'v2-bg-yellow-50 px-4 border v2-border-neutral-300 border-solid',
        'focus:v2-border-yellow-500 active:v2-border-yellow-500 hover:v2-border-yellow-500',
      ])}
      options={CARD_INPUT_OPTIONS}
      onChange={(evt) => onChange?.(evt as CreditCardValue)}
    />
  );
}
